module.exports = __webpack_public_path__ + "img/detail-mode2-3.79ac20fc.png";